import { formatDate } from '@/lib/dateFormat';

export type PlannedPeriodInput = {
  startDate?: string | null;
  lessonCount?: number | null;
  intervalWeeks?: number | null;
};

function parseDateOnly(value: string): Date | null {
  const raw = String(value || '').trim();
  if (!raw) return null;
  const parsed = new Date(`${raw.slice(0, 10)}T12:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function formatDateOnly(value: Date): string {
  return formatDate(value.toISOString().slice(0, 10));
}

/** Erstes und letztes Unterrichtsdatum aus Start + Einheiten × Intervall. */
export function computePlannedPeriodRange(input: PlannedPeriodInput): {
  start: string | null;
  end: string | null;
  label: string;
} {
  const start = parseDateOnly(String(input.startDate ?? ''));
  const units = typeof input.lessonCount === 'number' && input.lessonCount > 0
    ? input.lessonCount
    : 0;
  const interval = typeof input.intervalWeeks === 'number' && input.intervalWeeks > 0
    ? input.intervalWeeks
    : 1;

  if (!start || units <= 0) {
    const fallback = input.startDate ? formatDate(String(input.startDate).slice(0, 10)) : null;
    return {
      start: fallback,
      end: null,
      label: fallback ?? '—',
    };
  }

  const endDate = new Date(start);
  endDate.setDate(endDate.getDate() + (units - 1) * interval * 7);

  const startLabel = formatDateOnly(start);
  const endLabel = formatDateOnly(endDate);
  return {
    start: startLabel,
    end: endLabel,
    label: `${startLabel} – ${endLabel}`,
  };
}
